import colors from './colors.json';

type ColorType = 'primary' | 'secondary' | 'third';

export const getColor = (index: number, type: ColorType = 'primary'): string => colors[type][index];
